import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
    // name: 'getActiveFields',
    name: 'safe'
})

// export class CustomPipes implements PipeTransform {
//     transform(items: any[]): any[] {
//         return items.filter(it => {
//             if (it.status == true) {
//                 return it;
//             }
//             //return this.tempItems;//it.status==searchText;
//         });
//     }

// }
export class SafePipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}